import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'HEADCOUNT/MODAL';

export const {action: clear} = createAction(`${domain}/CLEAR`, () => ({}));
